// extracted by mini-css-extract-plugin
export var readonly = "_ge-1";
export var star = "_ge-0";